import { IAppParatemers } from "../../interfaces/IAppParatemers";
import { useModifyApplicationConfiguration } from "../../configuration/ConfigurationContext";
import { IAppConfigurations } from "../../interfaces/AppConfigurations";
import { useTranslation } from "react-i18next";

export type IUseApplyParameters = () => {
    apllyParameters: (parameters: IAppConfigurations) => void;
}

export const useApplyParameters: IUseApplyParameters = () => {
    const { setConfig } = useModifyApplicationConfiguration();
    const i18n = useTranslation().i18n;

    const apllyParameters = (parameters: IAppConfigurations) => {
        //console.info("[useApplyParameters]: Setting application parameters", { parameters });

        if (parameters.kaannokset) {
            Object.keys(parameters.kaannokset).forEach((lang) => {
                const rsc = (parameters as any).kaannokset[lang];
                if (rsc && typeof rsc === "object") {
                    i18n.addResources(lang, "translations", rsc)
                }
            })
        }


        setConfig({
            companyName: parameters.yritys.nimi,
            companyAddress: parameters.yritys.katuosoite,


            emailSupport: parameters.sahkopostit.aktivoitu,
            smsSupport: parameters.tekstiviestit.aktivoitu,
            mapSupport: parameters.kartat.aktivoitu,

            showDeveloperSettings: parameters.kehitysvalikko,
            showRawApplicationErrors: parameters.virheviestit,

            testenviromentBackground: parameters.testi.taustakuva,

            showLanguageSelect: parameters.kielivalikko,
            languages: parameters.kielet,

            showAuditSummary: parameters.auditointi?.yhteenveto,
            customConfigurationsLoaded: true,
            // applicationMenuHref: parameters.applicationMenuHref,
            registerSettings: parameters.kohderekisteri
        });
    }

    return ({
        apllyParameters
    })

};
